import { render } from "./CreateItemForm.vue?vue&type=template&id=0bbbf65a&scoped=true"
import script from "./CreateItemForm.vue?vue&type=script&lang=js"
export * from "./CreateItemForm.vue?vue&type=script&lang=js"

import "./CreateItemForm.vue?vue&type=style&index=0&id=0bbbf65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbbf65a"]])

export default __exports__